'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dPolicy$002dCode$0024 from "./presto.types$-Policy-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_PolicyView$$anon$2(outer) {
  this.baz = null;
  this.bax = null;
  this.bay = false;
  this.bav = null;
  this.baw = false;
  this.baA = false;
  this.baB = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.baz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PolicyView$$anon$2 as $c_Lpresto_PolicyView$$anon$2 };
$p = $c_Lpresto_PolicyView$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PolicyView$$anon$2;
/** @constructor */
function $h_Lpresto_PolicyView$$anon$2() {
}
export { $h_Lpresto_PolicyView$$anon$2 as $h_Lpresto_PolicyView$$anon$2 };
$h_Lpresto_PolicyView$$anon$2.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.baz;
});
$p.t = (function() {
  if ((!this.bay)) {
    this.bax = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bay = true;
  }
  return this.bax;
});
$p.ae = (function() {
  if ((!this.baw)) {
    this.bav = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPolicy$002dCode$0024.$m_Lpresto_types$PolicyCode$().adB(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.baw = true;
  }
  return this.bav;
});
$p.w = (function() {
  if ((!this.baB)) {
    this.baA = false;
    this.baB = true;
  }
  return this.baA;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PolicyView$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PolicyView$$anon$2, "presto.PolicyView$$anon$2", ({
  N3: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PolicyView$$anon$2 as $d_Lpresto_PolicyView$$anon$2 };
//# sourceMappingURL=presto.-Policy-View$$anon$2.js.map
